#### Webhook event payload `hirerId` field

We’ve extended the [webhook event payload] with a new [`hirerId`] field.

This field is only available on signed webhook subscriptions.
This will allow your software to efficiently filter or forward events on a per-hirer basis for partner-scoped subscriptions instead of requiring a follow up query.

[webhook event payload]: /schema/webhooks
[`hirerid`]: /schema/webhooks/CandidateApplicationCreatedEvent#/property/hirerId
